// import * as L from "leaflet";
// import "leaflet.markercluster";
// import "leaflet/dist/leaflet.css";
// import { useEffect, useState } from "react";
// import { LayersControl, MapContainer, TileLayer ,GeoJSON} from "react-leaflet";
// import { useNavigate } from "react-router-dom";
// var myIcon = L.icon({
//   iconUrl: require("./marker4.jpg"),
//   iconSize: [24, 35],
//   iconAnchor: [12, 35],
//   popupAnchor: [0, -35],
// });
// const getColor = (ACS) => {
//   if(ACS===null) return "blue";
//   if (ACS < 50) return "red";
//   if (ACS >= 50 && ACS <= 60) return "yellow";
//   return "green";
// };
// const FarmerMap = (props) => {
//   const navigate = useNavigate();
//   const [geoJson, setGeoJson] = useState();
//   useEffect(() => {
//     if (props.showGeojson) {
//       setGeoJson(props.showGeojson);
//     }
//   }, [props]);

//   useEffect(() => {
//     const map = L.map("mapId", {
//       center: [28.6591285, 77.3165729],
//       zoom: 6,
//     });

//     const googleSatellite = L.tileLayer("http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}", {
//       maxZoom: 19,
//       attribution: "© OpenStreetMap",
//     }).addTo(map);
//      const streetLayer = L.tileLayer(
//           "http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}",
//           { maxZoom: 22, attribution: "© Google" }
//         );

//     if (geoJson) {
//       if (geoJson.features.length != 0) {
//         map.fitBounds(L.geoJSON(geoJson).getBounds());

//         var markersBar = L.markerClusterGroup();
//         var barLayer = new L.geoJson(geoJson, {
//           style: (feature) => ({
//             color: getColor(feature.properties.ACS),
//             weight: 2,
//             fillOpacity: 0.5,
//           }),
//           pointToLayer: function(feature, latlng) {
//             return L.marker(latlng, { icon: myIcon });
//           },
//           onEachFeature: function(feature, layer) {

//             const Wrapperdiv = document.createElement("div");
//             Wrapperdiv.className = "farmer-info-wrapper";

//             Wrapperdiv.innerHTML = `<div className="farmerName">
//           <div>
//           <b >Farmer Name </b>: ${feature.properties.farmer_name}
//            </div><br/>
//            <div>
//            <b> Mobile Number  </b>:<span> ${feature.properties.phone_number}</span>
//             </div><br/>
//           <div>
//           <b> State  </b>: ${feature.properties.state_name}
//            </div><br/>
//            <div>
//            <b> District </b> : ${feature.properties.district_name}
//             </div><br/>
//             <div>
//               <b> Land Mark  </b>: ${feature.properties.land_mark}
//                </div><br/>
//               <b class=""> Plot Id  </b>: ${feature.properties.plot_id}
//             </div><br/>
//             <div>
//               <b> ACS  </b>: ${feature.properties.ACS===null?0:feature.properties.ACS}
//                </div>
//            <div>`;

//             const button = document.createElement("button");
//             button.innerHTML = "View Details";
//             button.style.cssText +=
//               "color:white;background-color:green;padding:7px;border:1px solid transparent;width:100%";

//             button.onclick = function() {
//               navigate(`/onboarding/farmers/${feature.properties.farmer_id}`);
//             };

//             Wrapperdiv.appendChild(button);
//             return layer.bindPopup(Wrapperdiv);
//           },
//         });
//         markersBar.addLayer(barLayer).addTo(map).bringToFront();

//         const baseLayers = {
//           "Google Satellite": googleSatellite,
//           "Google Street View": streetLayer,
//         };
//         const overlayLayers = {

//           Plots: markersBar,
//         };
//         L.control.layers(baseLayers, overlayLayers, { collapsed: false }).addTo(map);
//         markersBar.addLayer(barLayer);
//         map.addLayer(markersBar);
//          const legend = L.control({ position: "bottomright" });
//                 legend.onAdd = function (map) {
//                   const div = L.DomUtil.create("div", "info legend custom-legend");
//                   const grades = ["High", "Moderate", "Low"]
//                   const colors = ["green", "yellow", "red"];
//                   let labels = ["<h6 style='margin-bottom: 10px;'>Farm Score</h6>"];
//                   for (let i = 0; i < grades.length; i++) {
//                     labels.push(
//                       `<div style="display: flex; align-items: center; margin-bottom: 8px;">
//                         <i style="background:${colors[i]}; width:18px; height:18px; display:inline-block; margin-right:8px; border:1px solid #000;"></i>
//                         <span style="font-size:14px;">${grades[i]}</span>
//                       </div>`
//                     );
//                   }
//                   div.innerHTML = labels.join("");
//                   return div;
//                 };

//                 legend.addTo(map);
//       }
//     }

//     return () => {
//       map.off();
//       map.remove();
//     };
//   }, [geoJson]);

//   return (
//     <div
//       style={{
//         padding: 0,
//         margin: 0,
//         width: "100%",
//         height:"100%",
//         zIndex: 0,
//       }}
//       id="mapId"
//       className="farmer_map"
//     ></div>
//   );
// };

// export default FarmerMap;



//final ome

import * as L from "leaflet";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
  Popup,
  useMapEvents,
  LayerGroup,
} from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { ReactLegendMap } from "features/dashboard/Project/ReactLegendMap";

const pointIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -35],
});

const polygonCenterIcon = L.icon({
  iconUrl:
    "https://www.iconarchive.com/download/i113269/icons-land/flat-vector-map-marker/Marker-Pearl-HeadPin-Red.1024.png",
  iconSize: [0, 0],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

const getColor = (ACS) => {
  if (ACS === null || typeof ACS === "object") return "blue";

  if (ACS < 50) return "red";
  if (ACS >= 50 && ACS <= 60) return "yellow";
  return "green";
};

const ZoomTracker = ({ onZoomChange }) => {
  useMapEvents({
    zoomend: (e) => onZoomChange(e.target.getZoom()),
  });
  return null;
};

const FarmerMap = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [geoJson, setGeoJson] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(5);

  useEffect(() => {
    if (props.showGeojson) {
      setGeoJson(props.showGeojson);
    }
  }, [props.showGeojson]);

  useEffect(() => {
    if (geoJson) {
      try {
        const leafletBounds = L.geoJSON(geoJson).getBounds();
        setBounds(leafletBounds);
      } catch (err) {
        console.warn("Failed to compute bounds:", err);
      }
    }
  }, [geoJson]);
  // console.log("geojson check", geoJson);
  const polygonFeatures = useMemo(
    () =>
      geoJson?.features?.filter(
        (feature) =>
          feature?.geometry &&
          ["Polygon", "MultiPolygon"].includes(feature.geometry.type) &&
          feature.properties
      ) || [],
    [geoJson]
  );

  const pointFeatures = useMemo(
    () =>
      geoJson?.features?.filter(
        (feature) =>
          feature?.geometry?.type === "Point" &&
          Array.isArray(feature.geometry.coordinates) &&
          feature.properties
      ) || [],
    [geoJson]
  );
 
  // const combinedMarkers = useMemo(() => {
  //   console.log("pointFeatures",pointFeatures)
  //   const pointMarkers = pointFeatures.map((feature, idx) => {
  //     const [lng, lat] = feature.geometry.coordinates;
  //     return {
  //       key: `point-${feature.properties.plot_id ?? `idx-${idx}`}`,
  //       position: [lat, lng],
  //       icon: pointIcon,
  //       plotId: feature.properties.plot_id,
  //       feature,
  //     };
  //   });
  //   console.log("pointMarkers",pointMarkers)
  //   const existingPlotIds = new Set(pointMarkers.map((m) => m.plotId));
  //   console.log("existingPlotIds",existingPlotIds)
  //   console.log("polygonFeatures",polygonFeatures)
  //   const polygonCenterMarkers = polygonFeatures
  //     .filter((feature) => {
  //       const plotId = feature.properties.plot_id;
  //       return plotId && !existingPlotIds.has(plotId);
  //     })
  //     .map((feature, idx) => {
  //       const bounds = L.geoJSON(feature).getBounds();
  //       if (!bounds.isValid()) return null;
  //       const latlng = bounds.getCenter();
  //       return {
  //         key: `poly-center-${feature.properties.plot_id}-${idx}`,
  //         position: [latlng.lat, latlng.lng],
  //         icon: polygonCenterIcon,
  //         feature,
  //       };
  //     })
  //     .filter(Boolean);
  //     console.log("polygonCenterMarkers",polygonCenterMarkers)
  //   return [...pointMarkers, ...polygonCenterMarkers];
  // }, [pointFeatures, polygonFeatures]);

  const combinedMarkers = useMemo(() => {
    const uniquePointMap = new Map();
    //  console.log("pointFeatures :", pointFeatures);
  // console.log("polygonFeatures:", polygonFeatures);
    pointFeatures.forEach((feature) => {
      const plotId = feature.properties.plot_id;
      if (plotId && !uniquePointMap.has(plotId)) {
        uniquePointMap.set(plotId, feature);
      }
    });

    const pointMarkers = Array.from(uniquePointMap.values()).map(
      (feature, idx) => {
        const [lng, lat] = feature.geometry.coordinates;
        return {
          key: `point-${feature.properties.plot_id ?? `idx-${idx}`}`,
          position: [lat, lng],
          icon: pointIcon,
          plotId: feature.properties.plot_id,
          feature,
        };
      }
    );

    const existingPlotIds = new Set(pointMarkers.map((m) => m.plotId));

    const uniquePolygonMap = new Map();
    polygonFeatures.forEach((feature) => {
      const plotId = feature.properties.plot_id;
      if (
        plotId &&
        !existingPlotIds.has(plotId) &&
        !uniquePolygonMap.has(plotId)
      ) {
        uniquePolygonMap.set(plotId, feature);
      }
    });
    // console.log("uniquePolygonMap",uniquePolygonMap)
    const polygonCenterMarkers = Array.from(uniquePolygonMap.values())
      .map((feature, idx) => {
        const bounds = L.geoJSON(feature).getBounds();
        if (!bounds.isValid()) return null;
        const latlng = bounds.getCenter();
        return {
          key: `poly-center-${feature.properties.plot_id ?? `idx-${idx}`}`,
          position: [latlng.lat, latlng.lng],
          icon: polygonCenterIcon,
          plotId: feature.properties.plot_id,
          feature,
        };
      })
      .filter(Boolean);
    //  console.log("Point :", pointMarkers);
  // console.log("Polygon:", polygonCenterMarkers);
    return [...pointMarkers, ...polygonCenterMarkers];
  }, [pointFeatures, polygonFeatures]);

  // console.log("combinedMarkers", combinedMarkers);
  // console.log("GeoJSON :", geoJson?.features?.length);
 
  return (
    <div style={{ position: "relative", height: "100%", width: "100%",zIndex:0 }}>
      <MapContainer
        center={bounds ? undefined : [22, 80]}
        zoom={bounds ? undefined : 5}
        bounds={bounds}
        style={{ height: "100%", width: "100%" }}
        whenCreated={(map) => setZoom(map.getZoom())}
      >
        <ZoomTracker onZoomChange={setZoom} />

        <LayersControl collapsed={false}>
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer url="https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"  maxZoom={22}/>
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite With Labels" checked>
            <TileLayer url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"  maxZoom={22} />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Streets">
            <TileLayer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}"  maxZoom={22}/>
          </LayersControl.BaseLayer>

          <LayersControl.Overlay name="Plots" checked>
            <LayerGroup>
              {polygonFeatures.map((feature, idx) => (
                <GeoJSON
                  key={`polygon-${idx}`}
                  data={feature}
                  style={{
                    color: getColor(feature?.properties?.ACS ?? null),
                    weight: 2,
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={(feature, layer) => {
                    const Wrapperdiv = document.createElement("div");
                    Wrapperdiv.className = "farmer-info-wrapper lineHeight";
                    Wrapperdiv.innerHTML = `<div className="farmerName">
                      <div><b>Farmer Name</b>: ${
                        feature.properties.farmer_name
                      }</div>
                      <div><b>Mobile Number</b>: ${
                        feature.properties.phone_number
                      }</div>
                      <div><b>State</b>: ${feature.properties.state_name}</div>
                      <div><b>District</b>: ${
                        feature.properties.district_name
                      }</div>
                      <div><b>Land Mark</b>: ${
                        feature.properties.land_mark
                      }</div>
                      <div><b>Plot Id</b>: ${feature.properties.plot_id}</div>
                      <div><b>ACS</b>: ${feature.properties.ACS ?? 0}</div>
                    </div>`;
                    const btn = document.createElement("button");
                    btn.innerHTML = "View Details";
                    btn.style.cssText = `
                      color: white;
                      background-color: green;
                      padding: 7px;
                      border: none;
                      width: 100%;
                      margin-top: 10px;
                    `;
                    btn.onclick = () =>
                      navigate(
                        `/onboarding/farmers/${feature.properties.farmer_id}`
                      );
                    Wrapperdiv.appendChild(btn);
                    layer.bindPopup(Wrapperdiv);
                  }}
                />
              ))}
               {/* {console.log("combinedMarkers",combinedMarkers)} */}
              <MarkerClusterGroup
                chunkedLoading
                showCoverageOnHover={false}
                // iconCreateFunction={(cluster) => {
                //   const count = cluster.getChildCount();
                //   return L.divIcon({
                //     html: `<div style="background-color: rgba(0, 123, 255, 0.6); border-radius: 20px; padding: 6px 12px; color: white;">${count}</div>`,
                //     className: "custom-point-cluster",
                //     iconSize: L.point(40, 40),
                //   });
                // }}
              >
                {combinedMarkers.map(({ key, position, icon, feature }) => (
                  <Marker key={key} position={position} icon={icon}>
                    <Popup>
                      <div className="farmer-info-wrapper2">
                        <div className="mt-3">
                          <b>Farmer Name</b>: {feature.properties.farmer_name}
                        </div>
                        <div className="mt-3">
                          <b>Phone</b>: {feature.properties.phone_number}
                        </div>
                        <div className="mt-3">
                          <b>State</b>: {feature.properties.state_name}
                        </div>
                        <div className="mt-3">
                          <b>District</b>: {feature.properties.district_name}
                        </div>
                        <div className="mt-3">
                          <b>Land Mark</b>: {feature.properties.land_mark}
                        </div>
                        <div className="mt-3">
                          <b>Plot Id</b>: {feature.properties.plot_id}
                        </div>
                        <div className="mt-3">
                          <b>ACS</b>: {feature.properties.ACS ?? 0}
                        </div>
                        <button
                          style={{
                            color: "white",
                            backgroundColor: "green",
                            padding: "7px",
                            border: "none",
                            width: "100%",
                            marginTop: "10px",
                          }}
                          onClick={() =>
                            navigate(
                              `/onboarding/farmers/${feature.properties.farmer_id}`
                            )
                          }
                        >
                          View Details
                        </button>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MarkerClusterGroup>
            </LayerGroup>
          </LayersControl.Overlay>
        </LayersControl>
        <ReactLegendMap />
      </MapContainer>
    </div>
  );
};

export default FarmerMap;

